import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import moment from 'moment';
import { LogsApiResponse } from './logs.models';
import { ApiResponse } from '../../../common/models/api-response.model';
import { ENDPOINTS } from '../../../common/constants/endpoints.constants';

@Injectable({
  providedIn: 'root',
})
export class LogsService {
  http = inject(HttpClient);

  getLogsList(
    page: number,
    per_page: number,
    filter: Record<string, string | string[]> = {},
    sort?: { key: string; value: 'asc' | 'desc' }
  ) {
    let params = new HttpParams()
      .append('page', String(page))
      .append('per_page', String(per_page));

    if (sort?.key) {
      params = params.append(`sort[${sort.key}]`, sort.value);
    }

    params = this.handleDateFilter(filter, params);

    Object.entries(filter).forEach(([key, value]) => {
      if (key === 'creationDateEnd' || key === 'creationDateStart') {
        return;
      }

      if (Array.isArray(value)) {
        value.forEach((v, index) => {
          params = params.append(`filters[${key}][${index}]`, String(v));
        });
      } else {
        params = params.append(`filters[${key}]`, String(value));
      }
    });

    return this.http.get<ApiResponse<LogsApiResponse>>(
      `${ENDPOINTS.Logs.getLogsList}`,
      { params }
    );
  }

  handleDateFilter(
    filter: Record<string, string | string[]>,
    params: HttpParams
  ): HttpParams {
    if (filter['creationDateEnd'] && filter['creationDateStart']) {
      params = params.append(
        'filters[fromDate]',
        moment(filter['creationDateStart'])
          .startOf('day')
          .format('YYYY-MM-DD HH:mm:ss')
      );
      params = params.append(
        'filters[toDate]',
        moment(filter['creationDateEnd'])
          .endOf('day')
          .format('YYYY-MM-DD HH:mm:ss')
      );
    }
    return params;
  }
}
